import ApiBudgety from '@/api/apiBudgety'

export const bancoCentralService = {
  getValorLibraEsterlina,
}

async function getValorLibraEsterlina() {
  return await ApiBudgety.get('BancoCentral/ValorLibraEsterlina')
}
